/**
 * Created by Ning Jiang on 2022-09-19.
 */

import {SerialSymbol} from "./SerialSymbol";
import {SerialSymbolState} from "./SerialSymbolConfig";
import {SerialGameAssets} from "../SerialGameAssets";
import {Serial} from "../Serial";
import {SerialSound} from "../sound/SerialSound";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {Layers, SerialLayers} from "../view/SerialLayers";
import {gsap} from "gsap";
import {SerialGameMode} from "../server/SerialGameMode";

export class XSplitSymbol extends SerialSymbol {

    public attachedValue:number;
    private _spine:PIXI.spine.Spine;
    private _animationContainer:PIXI.Container;
    private _poster:PIXI.Sprite;

    constructor(symbolName:string, reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        const names = symbolName.split(":");
        super(names[0], reelId, symbolHeight, initState);
        this.blockReelLandingSound = true;
        this._multiplierFont = SerialGameAssets.BITMAP_FONT_SCATTER;
        this._multiplierLetterSpacing = -15;
        this.attachedValue = parseInt(names[1]);
    }

    protected initAnimation() {
        super.initAnimation();

        this._animationContainer = new PIXI.Container();
        this._animationContainer.position.set(this._centerPosition.x, this._centerPosition.y);
    }

    private prepareSpine():void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("S2"));
            this._spine.autoUpdate = true;
            this._animationContainer.addChild(this._spine);
        }
    }

    public playLanding(init:boolean = false):gsap.core.Animation {
        const symId = init ? Serial.model.parsedInitData.scatterPositions[4] : Serial.model.parsedGameData.scatterPositions[4];
        Serial.ways.updateWays(this.reelId, symId, this.attachedValue, !init);

        this.prepareSpine();
        const tl = gsap.timeline();
        tl.add(() => {
            const position = this.getGlobalPosition();
            SerialLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(this._spine);
            this._spine.position.set(position.x, position.y);
            this._spine.state.setAnimation(0, "Landing", false);
            if(!init) {
                SerialSound.soundPlayer.playTrack({name : SerialSound.SCATTERS[3]});
            }
        });
        tl.add(() => {
            this._animationContainer.addChild(this._spine);
            this._spine.position.set(0, 0);
            this.showMultiplier(`+${this.attachedValue}`);
            if(!init) {
                SerialSound.soundPlayer.playTrack({name: SerialSound.SCATTER_PLUS});
            }
            if(init && (Serial.model.parsedInitData.nextMode.includes("SUPER")|| Serial.model.parsedInitData.nextMode === SerialGameMode.CAPWIN_GAME)) {
                this.afterCut();
            }
        }, this._spine.spineData.findAnimation("Landing").duration);
        return tl;
    }

    public playWinAttention():Promise<any> {
        this.prepareSpine();
        const tl = gsap.timeline();
        tl.add(() => {
            this._spine.state.setAnimation(0, "Attention", false);
        });
        tl.add(() => {}, this._spine.spineData.findAnimation("Attention").duration);
        return Promise.resolve(tl);
    }

    public playPoster():void {
        const position = this.getGlobalPosition();
        this._poster = new PIXI.Sprite(Serial.assetLoader.getTextures(`fsintro/Poster${this.symbolName}`)[0]);
        this._poster.anchor.set(0.5);
        this._poster.position.set(position.x, position.y);
        this._poster.rotation = MathHelper.randomNumberInRange(-10, 10) * Math.PI / 180
        SerialLayers.getLayer(Layers.SCREENS)?.addChild(this._poster);
    }

    public removePoster():void {
        this._poster.parent.removeChild(this._poster);
        this._poster.destroy();
    }

    protected updateLayers() {
        if(this._animationContainer) {
            this.addChild(this._animationContainer);
        }
        super.updateLayers();
    }

    public startSpin():void {
        this.prepareSpine();
        this._spine.state.setAnimation(0, "Loop", true);
    }

    public stopSpin():void {
        this.prepareSpine();
        const track = this._spine.state.setAnimation(0, "Loop", false);
        track.trackTime = track.animation.duration;

    }

    public showMultiplier(text:string):gsap.core.Animation {
        const ani = super.showMultiplier(text);
        this._multiplierContainer.position.set(18, 22);
        return ani;
    }

    public afterCut():void {
        this._multiplierContainer.visible = false;
        // this.getStateAnimation(SerialSymbolState.WIN,
        //     {duration : 0.1, alpha : 1},
        //     {duration : 0.1, alpha : 0});
        this.prepareSpine();
        const track = this._spine.state.setAnimation(0, "Attention", false);
        track.trackTime = track.animation.duration;
    }
}